import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout';
import { IqServiceInventoryLibrary } from '@/components/features/merchants/iq-service-inventory/iq-service-inventory-library';

/**
 * Per-merchant IQ-service inventory (Spec 344, UC-1). Separate routed page reached
 * from the merchant detail page (analog to the asset library). Platform-only
 * (route gate IQ_SERVICE_INVENTORY_ACCESS). Distinct from the platform /iq-services
 * (Gateway-Config).
 */
export function MerchantIqServicesPage() {
  const { t } = useTranslation('iq-service-inventory');
  const { id } = useParams<{ id: string }>();

  return (
    <div>
      <PageHeader title={t('page.title')} description={t('page.description', { merchant: id ?? '' })} />
      <IqServiceInventoryLibrary merchantId={id ?? ''} />
    </div>
  );
}
